import axios from "axios";
import { Auth_Proto, Auth_Domain, Auth_Port } from "../Component/consts";

const api = axios.create({
    baseURL: `${Auth_Proto}${Auth_Domain}${Auth_Port}/api/masters`,
});

export const paymentGatewayConfigurationApi = {
    getAll: () => api.get("/payment-gateway-configurations"),
    getById: (id) => api.get(`/payment-gateway-configurations/${id}`),
    create: (payload) => api.post("/payment-gateway-configurations", payload),
    update: (id, payload) => api.put(`/payment-gateway-configurations/${id}`, payload),
    delete: (id) => api.delete(`/payment-gateway-configurations/${id}`),
};